import { Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { fluVaxFormFields } from '../../../services/formFields';
import NavigationButtons from './components/navigationButtons';
import TextAreaReligious from './components/textAreaReligious';
import TextAreaReligiousAdditionalInfo from './components/textAreaReligiousAdditionalInfo';
import useFormSubmit from './components/useFormSubmit';
import { FieldValidationErrorMsg, RequiredAsterisk } from '../../../sitel/demon/ui/atoms/form';

const schema = yup.object({
  [fluVaxFormFields.religiousBeliefFlu.key]: yup.string().required('This field must be filled'),
  [fluVaxFormFields.howReligiousBeliefRestrictsFlu.key]: yup.string().required('This field must be filled'),
  [fluVaxFormFields.howReligiousBeliefPreventsFlu.key]: yup.string().required('This field must be filled'),
  [fluVaxFormFields.hasReligiousExemption.key]: yup.string().required('Please select one').nullable(),
});

export default function RelFluVaxForm({ exemptionType, requestId, fieldsJSON, moreInfoFieldsJSON }) {
  const defaultValues = fieldsJSON;
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm({ resolver: yupResolver(schema), values:defaultValues });
  const onSubmit = useFormSubmit(exemptionType, requestId);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Container className='mt-1 mt-md-5'>
        <TextAreaReligious 
            defaultValues={defaultValues}
            id={fluVaxFormFields.religiousBeliefFlu.key}
            labelText={fluVaxFormFields.religiousBeliefFlu.label}
            register={register}
            errors={errors} 
            showIsRequired />

        <TextAreaReligious 
            defaultValues={defaultValues}
            id={fluVaxFormFields.howReligiousBeliefRestrictsFlu.key}
            labelText={fluVaxFormFields.howReligiousBeliefRestrictsFlu.label}
            register={register}
            errors={errors}
            showIsRequired />

        <TextAreaReligious 
            defaultValues={defaultValues}
            id={fluVaxFormFields.howReligiousBeliefPreventsFlu.key}
            labelText={fluVaxFormFields.howReligiousBeliefPreventsFlu.label}
            register={register}
            errors={errors}
            showIsRequired />

  		<div className='form-group row align-items-start py-3 p-md-2'>
          <label htmlFor='hasReligiousExemption' className='col-md-6 col-form-label'>
            {fluVaxFormFields.hasReligiousExemption.label}
            <RequiredAsterisk />
          </label>
          <div className='col-md-6'>
            <div className='form-check form-check-inline'>
              <label htmlFor='yes'>
                <input {...register('hasReligiousExemption', { required: true })} type='radio' name='hasReligiousExemption' value='yes' className='form-check-input' id='yes' /> Yes
              </label>
            </div>
            <div className='form-check form-check-inline'>
              <label htmlFor='No'>
                <input {...register('hasReligiousExemption', { required: true })} type='radio' name='hasReligiousExemption' value='No' className='form-check-input' id='No' /> No
              </label>
            </div>
            <div>
              <FieldValidationErrorMsg field='hasReligiousExemption' errors={errors} />
            </div>
          </div>
        </div>

        <TextAreaReligiousAdditionalInfo moreInfoRequest={moreInfoFieldsJSON} register={register} errors={errors} />

      </Container>
      <NavigationButtons isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful}/>
    </form>
  );
}
